export default {
    computed: {
        sessionKey() {
            // noinspection BadExpressionStatementJS // Used to trigger recomputation
            this.$store.state.reevaluateLogin;
            return this.$cookies.get("sessionKey");
        }
    },
    methods: {
        reloadUser() {
            if(typeof this.sessionKey === 'string') {
                this.apiRequest("GET", "/account")
                    .then(async cnt => {
                        this.$store.commit("setUser", cnt);
                    })
                    .catch(err => console.log(err));
                return true;
            }
            return false;
        },
        destroySession() {
            this.$store.commit('setUser', null);
            this.$cookies.remove("sessionKey");
            this.$store.state.reevaluateLogin++;
        },
        setSession(key) {
            // vue-cookies: set(key, value, expire, path, domain, secure, sameSite)
            // Secure nur unter HTTPS (sonst verwirft der Browser das Cookie auf localhost).
            const secure = window.location.protocol === 'https:';
            this.$cookies.set("sessionKey", key, 0, "/", null, secure, "Lax");
            this.$store.state.reevaluateLogin++;
        },
    }


}